import { Stack } from "@chakra-ui/react";
import styled from "@emotion/styled";
import {
  ColorIcon,
  colors,
  getCdnImageSrc,
  responsive,
  useResponsive,
  VStack,
} from "goi_common";
import React from "react";

export default function GuideHead({
  title,
  date,
  imgSrc,
  isFeed,
}: {
  title: string;
  date: string;
  imgSrc: string;
  isFeed?: boolean;
}) {
  const { isBiggerThanLg } = useResponsive();
  return (
    <>
      <VStack
        width="100%"
        background={`url(${getCdnImageSrc(imgSrc)})`}
        backgroundSize="cover"
        backgroundPosition="50% 50%"
        css={responsive({
          height: { base: "300px", lg: "780px" },
          borderRadius: { base: "0 0 40px 40px", lg: 0 },
          overflow: "hidden",
        })}
      >
        <VStack
          width="100%"
          height="100%"
          background="linear-gradient(180deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0) 100%)"
          padding="0px 24px"
          justifyContent="center"
          alignItems="center"
        >
          <VStack
            className="lg_under_hidden"
            maxWidth={"720px"}
            width="100%"
            css={{ margin: "60px 0 0" }}
          >
            <h1
              css={{
                fontSize: 60,
                fontWeight: 400,
                color: colors.white,
                whiteSpace: "pre-line",
                letterSpacing: -0.5,
              }}
            >
              {title}
            </h1>
            <p className="subtitle_21_l white">{date}</p>
          </VStack>
        </VStack>
        <Stack alignItems="center" padding="20px 0">
          <DownAnimation>
            <ColorIcon
              name="arrow_right_small"
              color={colors.white}
              size={isBiggerThanLg ? 40 : 30}
              css={{
                transform: "rotateZ(90deg)",
                animation: ".5s ease-in 1s infinite slidein",
              }}
            />
          </DownAnimation>
        </Stack>
      </VStack>

      <VStack width="100%" className="lg_over_hidden" alignItems="center">
        <VStack
          maxWidth="720px"
          width="100%"
          padding="32px 24px 28px"
          gap="4px"
        >
          {!isFeed && (
            <p
              className="body_14_r gray800"
              css={{
                padding: "10px 16px",
                background: colors.warmGray150,
                width: "fit-content",
                borderRadius: "10px",
              }}
            >
              {date}
            </p>
          )}
          <h1 className="head_24_sb" css={{ whiteSpace: "pre-line" }}>
            {title}
          </h1>
        </VStack>
      </VStack>
    </>
  );
}

const DownAnimation = styled.div`
  @keyframes down {
    0% {
      transform: translateX(0px);
    }
    30% {
      transform: translateY(7px);
    }
    60% {
      transform: translateY(0px);
    }
    100% {
      transform: translateY(0px);
    }
  }

  animation: 1.1s down infinite linear alternate;
`;
